import { constants } from "@/config/constants";

// TODO: placeholder — doplňte reálné údaje (e-mail, adresa, IČO/DIČ, region, souřadnice).
const map = {
  lat: 50.0755,
  lng: 14.4378,
  placeholder: true,
};

const bbox = [map.lng - 0.012, map.lat - 0.008, map.lng + 0.012, map.lat + 0.008].join("%2C");

export const site = {
  name: "Petr Pavlásek",
  legalName: "Petr Pavlásek",
  tagline: "Spolehlivý partner od roku 2005",
  description:
    "Elektroinstalace, revize elektrických zařízení s oprávněním TIČR, BOZP a požární ochrana. Spolehlivý partner od roku 2005.",
  claim: "Elektroinstalace, revize, BOZP a požární ochrana",
  eyebrow: "Elektroinstalace · Revize · BOZP a požární ochrana",
  footerTagline:
    "Elektroinstalace, revize, BOZP a požární ochrana. Spolehlivý partner od roku 2005.",
  shortTagline: "Elektro · Revize · BOZP",
  url: "https://www.petrpavlasek.cz",
  locale: "cs_CZ",
  lang: "cs",
  phone: constants.phone,
  phoneRaw: constants.phoneRaw,
  phoneHref: constants.phoneHref,
  email: "info@petrpavlasek.cz",
  emailPlaceholder: true,
  emailHref: "mailto:info@petrpavlasek.cz",
  openingHours: constants.openingHours,
  responseTimeLabel: constants.responseTime,
  region: "[PLACEHOLDER – region a okolí]",
  regionPlaceholder: true,
  address: {
    full: "[PLACEHOLDER – název ulice, město, PSČ]",
    placeholder: true,
  },
  business: {
    ico: "[PLACEHOLDER – IČO]",
    dic: "[PLACEHOLDER – DIČ]",
    placeholder: true,
  },
  map: {
    ...map,
    embedUrl: `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${map.lat}%2C${map.lng}`,
    link: `https://www.google.com/maps/search/?api=1&query=${map.lat}%2C${map.lng}`,
  },
  priceRange: "$$",
} as const;

export type Site = typeof site;
